/**
 * Résolution d'une locale par fusion PROFONDE sur un dictionnaire de référence.
 *
 * Le repli portait sur la locale ENTIÈRE (`translations[lang] || translations.en`),
 * ce qui ne protégeait de rien : `translations.es` EXISTE, il est simplement
 * incomplet (5 sections sur 10, et pas de `hero.cta`). Les composants du site
 * public déréférencent sans garde — `t.services.items.map(...)`,
 * `t.approach.eyebrow` — donc en espagnol `t.services` valait `undefined` et TOUT
 * le site plantait (écran blanc), pas seulement la section manquante.
 *
 * Invariant rétabli, et structurel plutôt que ponctuel : une traduction incomplète
 * DÉGRADE vers la langue de référence, elle ne casse jamais. Compléter `es` aurait
 * réparé aujourd'hui ; la fusion protège aussi la prochaine locale partielle.
 *
 * Module séparé (fonction pure, aucun import) : testable sans React ni alias
 * de bundler.
 */

/** Dictionnaire de référence : celui qu'on garantit complet. */
export const BASE_LOCALE = "en";

/**
 * Fusionne `over` par-dessus `base`, en profondeur.
 * Les tableaux sont remplacés en bloc — une liste traduite est un tout, pas un patch.
 */
export const deepMerge = (base, over) => {
  if (over === undefined || over === null) return base;
  if (typeof over !== "object" || Array.isArray(over)) return over;
  if (!base || typeof base !== "object" || Array.isArray(base)) return over;
  const out = { ...base };
  for (const k of Object.keys(over)) out[k] = deepMerge(base[k], over[k]);
  return out;
};

/** Dictionnaire effectif pour `lang`, toujours complet vis-à-vis de la référence. */
export const resolveLocale = (translations, lang, baseLocale = BASE_LOCALE) =>
  deepMerge(translations[baseLocale], translations[lang]);
